import { createRoutine } from 'redux-saga-routines';

export const stakePeosRoutine = createRoutine('peos/STAKE_PEOS');
export const unStakePeosRoutine = createRoutine('peos/UNSTAKE_PEOS');
export const refundPeosRoutine = createRoutine('peos/REFUND_PEOS');
export const claimPeosRoutine = createRoutine('peos/CLAIM_PEOS');